/* eslint-disable */
let defaultTheme = {
  "theme-name": "light-solarbase",
  "$background-color": "#3B83B3",
  "$active-background-color": "#1a93ca",
  "$text-color": "#ffffff",
  "$active-text-color": "#ffffff"
};
let darkTheme = {
  "theme-name": "dark-solarbase",
  "$background-color": "#202831",
  "$active-background-color": "#191e24",
  "$text-color": "#7f8b94",
  "$active-text-color": "#40acfc"
};

export default {
  userList: [],
  userListAdmin: [],
  groupList: [],
  subgroupList: [],
  groupUsers: [],
  groupitemList: [],
  userAmount: null,
  emailList: [],
  installs: [],
  installss: [],
  smsList: [],
  deviceList: [],
  deviceList: [],
  dummy: "Dummy Data",
  loggedInUser: null,
  userAccess: "CUSTOMER",
  isHome: false,
  isSidebarCollapsed: true,
  drawerMode: false,
  allDevices: [],
  allGraphDevices: [],
  allOffDevices: [],
  devicesWarning: {},
  roles: [],
  rolesAdmin: [],
  graphDeviceDetails: [],
  offLineDeviceList: [],
  alarmDevices: [],
  criticalSystems: [],
  onLineDevices: [],
  uniqueFV: [],
  filteredAllDevices: [],
  filteredOnlineDevices: [],
  filteredAlarmDevices: [],
  filteredOffLineDevices: [],
  uniqueSectors: [],
  filterFirmWarVersion: "",
  filterPaymentModel: "",
  deviceCurrentSettings: [],
  filterSectorVal: "",
  performanceFilter: 1,
  loggedinUserRole: "",
  loggedinUserInstallationCount: "",
  globalTableOptions: {
    performance: {
      pagination: {
        currentPage: 1,
        prevPage: 1,
        currentPerPage: 50,
        total: 50
      }
    }
  },
  defaultTheme: {
    "theme-name": "light-solarbase",
    "$background-color": "#3B83B3",
    "$active-background-color": "#1a93ca",
    "$text-color": "#ffffff",
    "$active-text-color": "#ffffff"
  },
  darkTheme: {
    "theme-name": "dark-solarbase",
    "$background-color": "#202831",
    "$active-background-color": "#191e24",
    "$text-color": "#7f8b94",
    "$active-text-color": "#40acfc"
  },
  activeTheme: defaultTheme,
  osCustomer: {},
  customerProductOptions: {},
  onboanrdingState: 0,
  onboardingPackageType: {},
  activateCustomerType: "",
  loDetails: {
    quantity: 1,
    address: "",
    downPayment: 1,
    tenureMonth: 1,
    buildingType: ""
  },
  userNotifications: [],
  assignedDevices: null,
  onboardingCustomerState: {
    id: 0,
    paymentType: "", //ipp, lo, os
    selectedProduct: {}
    // stateid: 0,
    // products: []
  },
  activeDeviceDaysToExpire: 100,
  onboardingLoMonthlyAmount: 1,
  luxOnboardingStatus: {
    deviceId: "",
    serialNumbers: []
  },
  luxPaymentStatus: {
    paymentType: "",
    cLoadValue: "",
    deviceVersion: ""
  },
  luxCount: 1
};



// WEBPACK FOOTER //
// ./src/store/state.js